import { render, staticRenderFns } from "./user.vue?vue&type=template&id=0a34a1c3&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "../asset/css/login.scss?vue&type=style&index=0&id=0a34a1c3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34a1c3",
  null
  
)

export default component.exports